module.exports = __webpack_public_path__ + "fonts/stock-ai-no-permission.svg";